import React from 'react'
import { cn } from '../../lib/utils'

type AlertVariant = 'default' | 'destructive'

interface AlertProps {
  className?: string
  children: React.ReactNode
  variant?: AlertVariant
}

interface AlertDescriptionProps {
  className?: string
  children: React.ReactNode
}

const alertVariants = {
  default: 'border-border bg-background text-foreground',
  destructive: 'border-red-200 bg-red-50 text-red-900 [&>svg]:text-red-600'
}

export const Alert: React.FC<AlertProps> = ({ className, children, variant = 'default' }) => {
  return (
    <div className={cn(
      'relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground',
      alertVariants[variant],
      className
    )}>
      {children}
    </div>
  )
}

export const AlertDescription: React.FC<AlertDescriptionProps> = ({ className, children }) => {
  return (
    <div className={cn('text-sm [&_p]:leading-relaxed', className)}>
      {children}
    </div>
  )
}